import { connect } from 'react-redux'
import {
  compose,
  graphql,
} from 'react-apollo'
import { getAllNodesQuery } from '../queries'
import {
  createListMutation,
  createOptionMutation,
  createOptionGroupMutation,
  updateListMutation,
  updateRootMutation,
} from '../mutations'
import { getActiveNode } from '../selectors'
import { setActiveNode } from '../actions'
import AdminNodeListItem from '../components/adminNodeListItem'

const getNode = (nodes, id) => nodes && nodes.find(node => node.id === id)

const mapStateToProps = (state, ownProps) => ({
  active: getActiveNode({
    state,
    nodes: ownProps.nodes,
  }),
  node: getNode(ownProps.nodes, ownProps.id),
})

const mapDispatchToProps = dispatch => ({
  setActive: nodeId => dispatch(setActiveNode(nodeId)),
})

export default compose(
  graphql(createListMutation, {
    name: 'createListMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  graphql(createOptionMutation, {
    name: 'createOptionMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  graphql(createOptionGroupMutation, {
    name: 'createOptionGroupMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  graphql(updateListMutation, {
    name: 'updateListMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  graphql(updateRootMutation, {
    name: 'updateRootMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AdminNodeListItem)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminNodeListItem.js